import React from 'react';
import { ButtonLoader, ButtonLoaderVariants } from '../../../ButtonLoader/ButtonLoader';

export type RoundedBlueProps = {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    children?: React.ReactNode;
    disabled?: boolean;
    isLoading?: boolean;
};

export const RoundedBlue: React.FC<RoundedBlueProps> = ({
                                                            onClick,
                                                            children,
                                                            disabled,
                                                            isLoading,
                                                        }) => {
    return (
        <button
            className="disabled:cursor-not-allowed disabled:opacity-[0.4]"
            onClick={onClick}
            disabled={disabled || isLoading}
        >
            {isLoading ? <ButtonLoader variant={ButtonLoaderVariants.SMALL} /> : null}
            {children}
        </button>
    );
};
